import React, { FC } from 'react'
import { ClassNameValue } from 'tailwind-merge'
import cn from '../../lib/utils/cn'

interface ProgressBarProps {
	value: number
	maxValue: number
	color: string
	classNameWrapper?: ClassNameValue
	classNameInner?: ClassNameValue
	isLoading?: boolean
}

const ProgressBar: FC<ProgressBarProps> = ({
	value,
	maxValue,
	color,
	classNameWrapper,
	classNameInner,
	isLoading,
}) => {
	const percent = Math.min(100, Math.max(0, (value / maxValue) * 100))

	if (isLoading) {
		return (
			<div
				style={{
					backgroundImage: `linear-gradient(90deg, ${color}22 0%, ${color}77 45%, ${color}22 100%)`,
					backgroundSize: '200% 100%',
				}}
				className={cn(
					'relative w-full h-3 rounded-md overflow-hidden box-border animate-shimmer',
					classNameWrapper
				)}
			/>
		)
	}

	return (
		<div
			style={{
				backgroundColor: `${color}33`,
			}}
			className={cn(
				'relative w-full h-3 rounded-md overflow-hidden box-border',
				classNameWrapper
			)}
		>
			<div
				className={cn(
					'absolute left-0 top-0 h-full rounded-md',
					classNameInner
				)}
				style={{
					width: `${percent}%`,
					backgroundColor: color,
					transition: 'width 0.3s',
				}}
			/>
		</div>
	)
}

export default ProgressBar
